import { customerTraceHistory } from "@/constants/content";
import { useContainerWidth } from "@/hooks/useContainerWidth";
import { TabPanel, TabView } from "primereact/tabview";
import React from "react";

const CustomerTraceabilityHistory = () => {


  const tabContainerWidth = useContainerWidth("tabcontainer");

  return (
    <div className="flex flex-column align-items-center mx-2" id="tabcontainer">
      <TabView
        className='border-round'
        style={{
          width: tabContainerWidth ,
        }}
      >
        {customerTraceHistory?.map((item) => (
          <TabPanel key={item?.cte} header={item?.cte}>
            <div className="flex flex-column gap-3">
              {item.kdes?.length > 0 ? (
                item.kdes.map((kde, index) => {
                  return (
                    <div
                      key={index}
                      className="flex flex-row justify-content-between align-items-center gap-2"
                    >
                      <span className="text-left">{kde.label}</span>
                      <span className="text-right p-tag  bg-primary-100 text-primary-700">
                        {kde.value}
                      </span>
                    </div>
                  );
                })
              ) : (
                <p className="flex justify-content-center">No records found</p>
              )}
            </div>
          </TabPanel>
        ))}
      </TabView>
    </div>
  );
};

export default CustomerTraceabilityHistory;
